import React from 'react';
import DashboardCard from './DashboardCard';

const RevenueOverviewCard = ({ data }) => {
    if (!data) return null;

    const { revenue } = data;

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    return (
        <DashboardCard
            title="Revenue Overview"
            icon="fas fa-dollar-sign"
        >
            <div className="row mb-3">
                <div className="col-6">
                    <div className="text-center p-2 bg-dark rounded">
                        <div className="fs-4 fw-bold text-success">{formatCurrency(revenue.today)}</div>
                        <div className="text-light small">Today</div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="text-center p-2 bg-dark rounded">
                        <div className="fs-4 fw-bold text-primary">{formatCurrency(revenue.thisMonth)}</div>
                        <div className="text-light small">This Month</div>
                    </div>
                </div>
            </div>

            <div className="text-center mb-3 p-3 bg-dark rounded">
                <div className="text-light small mb-1">Total Credits Available</div>
                <div className="fs-3 fw-bold text-info">
                    {formatCurrency(revenue.totalCredits)} Cr
                </div>
            </div>

            {revenue.topOrganizations && revenue.topOrganizations.length > 0 && (
                <div>
                    <div className="text-light small mb-2 fw-bold">Top Spenders</div>
                    {revenue.topOrganizations.slice(0, 3).map((org, index) => (
                        <div key={org.organizationId} className="d-flex justify-content-between align-items-center mb-2 p-2 bg-dark rounded small">
                            <span className="text-light text-truncate" style={{ maxWidth: '65%' }}>
                                <span className="badge bg-primary text-black me-2">{index + 1}</span>
                                {org.organizationName}
                            </span>
                            <span className="text-success fw-bold">{formatCurrency(org.amount)} Cr</span>
                        </div>
                    ))}
                </div>
            )}
        </DashboardCard>
    );
};

export default RevenueOverviewCard;
